import {makeObservable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';
import type {EditionModel} from '../Edition/Edition.model';
import type {FileModel} from '../File/File.model';

import {EVERGREEN_PROGRAM_SCHEDULE_DURATION} from '../../../utils/entity/program';
import {BaseModel} from '../Base/Base.model';

const ModelName = 'ProgramModel';

export class ProgramModel extends BaseModel {
  avatar: Nullable<FileModel>;
  description: string;
  editions: EditionModel[];
  title: string;

  constructor(props: ProgramModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<ProgramModel, ProgramModel.Props>(props),
    );
  }

  get duration() {
    return this.lastEdition?.isEvergreen
      ? EVERGREEN_PROGRAM_SCHEDULE_DURATION
      : // TODO: multiply by offer.num_cycles
        (this.lastEdition?.duration.value ?? 0);
  }

  get lastEdition() {
    return this.editions.at(-1) ?? null;
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace ProgramModel {
  export type Props = BaseModel.ModelToProps<
    ProgramModel,
    'duration' | 'lastEdition'
  >;
}
